import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const CallbackPage = () => {
  const history = useHistory();

  useEffect(() => {
    const callbackUrl = localStorage.getItem('callbackUrl');
    localStorage.removeItem('callbackUrl');

    history.push(callbackUrl || '/');
  }, [history]);

  return null;
};

export default React.memo(CallbackPage);
